import PropTypes from "prop-types";
import Item from "../item";
import styles from "./styles";

const Category = ({ category, text, list = [], url }) => {
  return (
    <li>
      <h2 className={styles.title}>
        <a className={styles.link} href={url}>
          {category || text}
        </a>
      </h2>
      <ul className={styles.list}>
        {list.length > 0 &&
          list.map((item, index) => {
            return <Item key={index} {...item} />;
          })}
      </ul>
    </li>
  );
};

Category.propTypes = {
  category: PropTypes.string,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      text: PropTypes.string,
    })
  ),
  text: PropTypes.string,
  url: PropTypes.string,
};

export default Category;
